// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LinkOverlay = (_props: any): React.ReactElement => {
  return <></>;
};

export { LinkOverlay };
